import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// One type for every public page (owner, 31 Oct 2026: "Uniformity is
// critical"), the look approved on the new home: Geist throughout, titles
// semibold, small capital labels in Geist Mono at regular weight. It is a
// class on <html> (styles in index.css under `html.public-type`), set here for
// the marketing pages of parcelink.org, drivers. and partners. only, so the
// portal and every signed-in screen keep their own type.

const LEGAL = ['/privacy', '/terms', '/gdpr', '/disclaimer'];
const PAGES = {
  apex: ['/', '/preview/home', '/proof', '/about', '/software'],
  drivers: ['/'],
  partners: ['/', '/partner'],
};

export function publicSite(host = '') {
  const h = host.toLowerCase();
  if (['parcelink.org', 'www.parcelink.org', 'parcelink-local.parcelink.org', 'apex.localhost'].includes(h)) return 'apex';
  if (h === 'drivers.parcelink.org' || h === 'drivers-local.parcelink.org') return 'drivers';
  if (h === 'partners.parcelink.org' || h === 'partners-local.parcelink.org') return 'partners';
  return null;
}

export function isPublicPage(host, pathname = '/') {
  const site = publicSite(host);
  if (!site) return false;
  const p = pathname.replace(/\/+$/, '') || '/';
  return PAGES[site].includes(p) || LEGAL.includes(p)
    || p === '/blog' || p.startsWith('/blog/')
    || (site === 'drivers' && (p === '/jobs' || p.startsWith('/jobs/')));
}

const PublicType = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const on = isPublicPage(window.location.hostname, pathname);
    document.documentElement.classList.toggle('public-type', on);
  }, [pathname]);
  return null;
};

export default PublicType;
